var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadicalLineBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1043,
    height: 534,
    fill: "none",
    viewBox: "0 0 1043 534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m565.753 248.034 14.702 11.931a317.67 317.67 0 0 1 5.59 4.626s-2.552-2.07-5.59-4.626l-14.702-11.931a317.67 317.67 0 0 1-5.59-4.626s2.552 2.07 5.59 4.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m565.753 248.034 14.702 11.931m-14.702-11.931a317.67 317.67 0 0 1-5.59-4.626s2.552 2.07 5.59 4.626Zm14.702 11.931a317.67 317.67 0 0 1 5.59 4.626s-2.552-2.07-5.59-4.626Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M577.54 282s-.85-5.479-1.944-12.174l-4.982-31.774a1719.585 1719.585 0 0 1-1.944-12.174"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M551.293 287.722s4.253-6.574 9.478-14.609l24.666-38.104c5.225-8.035 9.478-14.609 9.478-14.609"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m601.356 246.451-56.624 15.217c-12.03 3.287-21.751 5.844-21.751 5.844s9.721-2.678 21.751-5.844l56.624-15.217c12.029-3.287 21.75-5.844 21.75-5.844s-9.721 2.679-21.75 5.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "m601.356 246.451-56.624 15.217m56.624-15.217c12.029-3.287 21.75-5.844 21.75-5.844s-9.721 2.679-21.75 5.844Zm-56.624 15.217c-12.03 3.287-21.751 5.844-21.751 5.844s9.721-2.678 21.751-5.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M516.42 225.147s11.057 5.6 24.667 12.54l64.036 32.626a11380.743 11380.743 0 0 0 24.666 12.539"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m588.354 293.808-30.5-79.496c-6.44-16.921-11.665-30.556-11.665-30.556s5.225 13.756 11.665 30.556l30.5 79.496c6.44 16.922 11.665 30.557 11.665 30.557s-5.225-13.757-11.665-30.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "m588.354 293.808-30.5-79.496m30.5 79.496c6.44 16.922 11.665 30.557 11.665 30.557s-5.225-13.757-11.665-30.557Zm-30.5-79.496c-6.44-16.921-11.665-30.556-11.665-30.556s5.225 13.756 11.665 30.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m555.425 300.017 35.238-91.913c7.534-19.478 13.488-35.304 13.488-35.304s-6.076 15.826-13.488 35.304l-35.238 91.913a4581.777 4581.777 0 0 0-13.487 35.305s6.075-15.827 13.487-35.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m555.425 300.017 35.238-91.913m-35.238 91.913a4581.777 4581.777 0 0 0-13.487 35.305s6.075-15.827 13.487-35.305Zm35.238-91.913c7.534-19.478 13.488-35.304 13.488-35.304s-6.076 15.826-13.488 35.304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m523.468 279.322 99.395-50.766c21.143-10.713 38.155-19.478 38.155-19.478s-17.133 8.765-38.155 19.478l-99.395 50.766c-21.143 10.713-38.155 19.478-38.155 19.478s17.134-8.765 38.155-19.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "m523.468 279.322 99.395-50.766m-99.395 50.766c-21.143 10.713-38.155 19.478-38.155 19.478s17.134-8.765 38.155-19.478Zm99.395-50.766c21.143-10.713 38.155-19.478 38.155-19.478s-17.133 8.765-38.155 19.478Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m512.896 237.809 120.539 32.383c25.638 6.817 46.295 12.417 46.295 12.417s-20.778-5.6-46.295-12.417l-120.539-32.383c-25.639-6.817-46.295-12.417-46.295-12.417s20.778 5.6 46.295 12.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m512.896 237.809 120.539 32.383m-120.539-32.383c-25.639-6.817-46.295-12.417-46.295-12.417s20.778 5.6 46.295 12.417Zm120.539 32.383c25.638 6.817 46.295 12.417 46.295 12.417s-20.778-5.6-46.295-12.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M639.511 356.504s-13.002-19.965-28.92-44.557l-75.093-115.895c-15.918-24.592-28.92-44.557-28.92-44.557"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M552.145 386.452s4.131-25.809 9.113-57.583l23.694-149.617c4.982-31.774 9.114-57.583 9.114-57.583"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M460.038 345.792s21.994-17.896 49.09-39.931l127.829-103.722c27.097-22.034 49.091-39.93 49.091-39.93"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m416.053 245.722 68.289 3.53 177.405 9.374 68.289 3.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "m453.72 134.33 51.885 51.983 134.998 135.252 51.885 51.982"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M563.566 73.339s1.823 35.182 4.132 78.522l10.693 204.278c2.308 43.339 4.131 78.522 4.131 78.522"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M694.191 104.26s-23.573 29.217-52.614 65.13L504.756 338.608c-29.041 35.913-52.614 65.13-52.614 65.13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M774.509 221.982s-39.248 6.209-87.609 13.879l-227.711 36.156c-48.361 7.67-87.609 13.878-87.609 13.878"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M753.973 371.722s-35.238-22.887-78.617-51.13L470.854 187.531a93987.463 93987.463 0 0 0-78.618-51.131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m539.872 129.581 66.466 248.714c14.096 52.834 25.639 95.687 25.639 95.687s-11.422-42.853-25.639-95.687l-66.466-248.714c-14.095-52.834-25.639-95.686-25.639-95.686s11.422 42.852 25.639 95.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m539.872 129.581 66.466 248.714m-66.466-248.714c-14.095-52.834-25.639-95.686-25.639-95.686s11.422 42.852 25.639 95.686Zm66.466 248.714c14.096 52.834 25.639 95.687 25.639 95.687s-11.422-42.853-25.639-95.687Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M464.535 467.408s21.143-41.513 47.146-92.765l122.726-241.287c26.003-51.252 47.146-92.765 47.146-92.765"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m705.368 203.112-264.65 101.774c-56.137 21.67-101.825 39.2-101.825 39.2s45.566-17.53 101.825-39.2l264.65-101.774c56.138-21.669 101.826-39.2 101.826-39.2s-45.566 17.531-101.826 39.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m705.368 203.112-264.65 101.774m264.65-101.774c56.138-21.669 101.826-39.2 101.826-39.2s-45.566 17.531-101.826 39.2Zm-264.65 101.774c-56.137 21.67-101.825 39.2-101.825 39.2s45.566-17.53 101.825-39.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M327.957 159.773s47.754 18.383 106.565 41.027l277.044 106.521c58.811 22.644 106.565 41.026 106.565 41.026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m643.398 392.296-140.71-276.713c-29.891-58.8-54.072-106.4-54.072-106.4s24.302 47.721 54.072 106.4l140.71 276.713c29.891 58.8 54.072 106.4 54.072 106.4s-24.302-47.722-54.072-106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m643.398 392.296-140.71-276.713m140.71 276.713c29.891 58.8 54.072 106.4 54.072 106.4s-24.302-47.722-54.072-106.4Zm-140.71-276.713c-29.891-58.8-54.072-106.4-54.072-106.4s24.302 47.721 54.072 106.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M647.044-22.592s-14.46 53.93-32.201 120.279l-83.599 312.747c-17.74 66.348-32.2 120.279-32.2 120.279"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "M822.626 91.6s-48.604 31.652-108.509 70.608L431.97 345.791C372.065 384.747 323.461 416.4 323.461 416.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m400.376 226.608 345.333 54.782a74620.88 74620.88 0 0 0 132.811 21.061s-59.54-9.495-132.811-21.061l-345.333-54.782c-73.27-11.687-132.811-21.061-132.811-21.061s59.541 9.496 132.811 21.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "m400.376 226.608 345.333 54.782m-345.333-54.782c-73.27-11.687-132.811-21.061-132.811-21.061s59.541 9.496 132.811 21.061Zm345.333 54.782a74620.88 74620.88 0 0 0 132.811 21.061s-59.54-9.495-132.811-21.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M775.116 504.052s-39.369-48.696-87.852-108.713L458.946 112.782C410.463 52.765 371.094 4.069 371.094 4.069"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M555.668 586.956s3.402-64.887 7.534-144.747l19.684-376.296c4.132-79.861 7.534-144.748 7.534-144.748"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M329.537 497.965 435.373 391.93l275.343-275.861L816.551 10.034"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M217.626 272.626s69.261-3.652 154.561-8.157l401.957-21.061c85.301-4.504 154.562-8.156 154.562-8.156"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "M287.251 22.209s55.652 45.165 124.305 100.8l323.097 262.104a250793.33 250793.33 0 0 1 124.305 100.8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "m513.868-121.444 25.76 163.252 67.074 424.504c14.217 90.087 25.76 163.252 25.76 163.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M452.627 439.773 693.461 68.225c51.156-78.886 92.591-142.921 92.591-142.921s-41.556 64.034-92.591 142.921L452.627 439.773c-51.156 78.887-92.591 142.922-92.591 142.922s41.557-64.035 92.591-142.922Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "M452.627 439.773 693.461 68.225M452.627 439.773c-51.156 78.887-92.591 142.922-92.591 142.922s41.557-64.035 92.591-142.922ZM693.461 68.225c51.156-78.886 92.591-142.921 92.591-142.921s-41.556 64.034-92.591 142.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M962.364 149.548s-75.823 20.33-169.264 45.409L353.11 313.044a831268.318 831268.318 0 0 1-169.264 45.408"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M942.558 442.573s-71.934-36.765-160.637-82.052L364.289 147.356c-88.702-45.287-160.637-82.052-160.637-82.052"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M725.904 652.817s-29.77-77.67-66.467-173.357L486.771 28.66c-36.696-95.687-66.466-173.356-66.466-173.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M661.868 22.452 484.463 485.548c-37.669 98.365-68.289 178.104-68.289 178.104l68.289-178.104L661.868 22.452c37.668-98.365 68.289-178.104 68.289-178.104L661.868 22.452Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "M661.868 22.452 484.463 485.548M661.868 22.452c37.668-98.365 68.289-178.104 68.289-178.104L661.868 22.452ZM484.463 485.548c-37.669 98.365-68.289 178.104-68.289 178.104l68.289-178.104Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M799.54 138.348 346.549 369.652c-96.115 49.061-174.246 88.992-174.246 88.992s78.01-39.809 174.246-88.992L799.54 138.47c96.115-49.061 174.246-88.992 174.246-88.992s-78.009 39.81-174.246 88.992v-.122Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M346.549 369.652 799.54 138.348v.122M346.549 369.652c-96.115 49.061-174.246 88.992-174.246 88.992s78.01-39.809 174.246-88.992Zm0 0L799.54 138.47m0 0c96.115-49.061 174.246-88.992 174.246-88.992s-78.009 39.81-174.246 88.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M825.056 321.687 321.152 186.435c-106.929-28.731-193.809-51.983-193.809-51.983s86.758 23.252 193.809 51.983l503.904 135.252c106.93 28.73 193.814 51.983 193.814 51.983s-86.763-23.253-193.814-51.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "M825.056 321.687 321.152 186.435m503.904 135.252c106.93 28.73 193.814 51.983 193.814 51.983s-86.763-23.253-193.814-51.983ZM321.152 186.435c-106.929-28.731-193.809-51.983-193.809-51.983s86.758 23.252 193.809 51.983Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M315.442-143.6s50.184 77.426 112.033 172.87l291.261 449.461C780.585 574.174 830.769 651.6 830.769 651.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M530.273 525.235 616.06-17.113c18.226-115.165 32.929-208.66 32.929-208.66s-14.824 93.495-32.929 208.66l-85.787 542.348a241369.407 241369.407 0 0 0-32.929 208.661s14.824-93.496 32.929-208.661Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M530.273 525.235 616.06-17.113m-85.787 542.348a241369.407 241369.407 0 0 0-32.929 208.661s14.824-93.496 32.929-208.661ZM616.06-17.113c18.226-115.165 32.929-208.66 32.929-208.66s-14.824 93.495-32.929 208.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "M958.962-58.992S883.747 1.999 791.156 77.112L354.933 431.008c-92.591 75.113-167.806 136.104-167.806 136.104"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m286.157 238.904 573.773 30.07c121.754 6.452 220.66 11.565 220.66 11.565s-98.906-5.235-220.66-11.565l-573.773-30.07c-121.753-6.452-220.663-11.565-220.663-11.565s98.91 5.235 220.663 11.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "m286.157 238.904 573.773 30.07m-573.773-30.07c-121.753-6.452-220.663-11.565-220.663-11.565s98.91 5.235 220.663 11.565Zm573.773 30.07c121.754 6.452 220.66 11.565 220.66 11.565s-98.906-5.235-220.66-11.565Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m780.827 462.174 159.907 160.208-159.907-160.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M780.827 462.174 365.26 45.826 205.353-114.383m575.474 576.557 159.907 160.208-159.907-160.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "M600.992 785.878s-5.468-103.6-12.151-231.304L557.37-46.696C550.687-174.4 545.219-278 545.219-278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M766.367 14.904 379.842 493.095c-82.019 101.531-148.729 183.948-148.729 183.948s66.588-82.417 148.729-183.948L766.367 14.904c82.02-101.53 148.729-183.948 148.729-183.948S848.508-86.627 766.367 14.904Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M766.367 14.904 379.842 493.095M766.367 14.904c82.02-101.53 148.729-183.948 148.729-183.948S848.508-86.627 766.367 14.904ZM379.842 493.095c-82.019 101.531-148.729 183.948-148.729 183.948s66.588-82.417 148.729-183.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "M24.91 341.043s106.808-16.922 238.404-37.861l619.704-98.365c131.592-20.939 238.402-37.861 238.402-37.861"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FD015F",
    strokeWidth: 0.6,
    d: "m97.694-55.339 206.69 134.522 537.319 349.635a57749079.98 57749079.98 0 0 0 206.687 134.521"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M657.737 570.4 488.472-62.4c-35.967-134.4-65.129-243.357-65.129-243.357S452.505-196.679 488.472-62.4l169.265 632.8c35.967 134.4 65.129 243.356 65.129 243.356S693.704 704.678 657.737 570.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M657.737 570.4 488.472-62.4m169.265 632.8c35.967 134.4 65.129 243.356 65.129 243.356S693.704 704.678 657.737 570.4ZM488.472-62.4c-35.967-134.4-65.129-243.357-65.129-243.357S452.505-196.679 488.472-62.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M421.641 551.774 724.567-43.774c64.279-126.487 116.528-229.113 116.528-229.113S788.967-170.261 724.567-43.774L421.641 551.774c-64.279 126.487-116.529 229.113-116.529 229.113s52.128-102.626 116.529-229.113Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "M421.641 551.774 724.567-43.774M421.641 551.774c-64.279 126.487-116.529 229.113-116.529 229.113s52.128-102.626 116.529-229.113ZM724.567-43.774c64.279-126.487 116.528-229.113 116.528-229.113S788.967-170.261 724.567-43.774Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA600",
    strokeWidth: 0.6,
    d: "M1135.15 37.791s-109.48 42.122-244.356 93.983l-635.258 244.33C120.66 427.965 11.179 470.087 11.179 470.087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m249.34 129.461 647.53 249.078c137.43 52.835 249.1 95.809 249.1 95.809s-111.55-42.852-249.1-95.809L249.34 129.461C111.79 76.626.243 33.652.243 33.652S111.79 76.504 249.34 129.461Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9DB",
    strokeWidth: 0.6,
    d: "m249.34 129.461 647.529 249.078M249.34 129.461C111.79 76.626.243 33.652.243 33.652S111.79 76.504 249.34 129.461Zm647.529 249.078c137.431 52.835 249.101 95.809 249.101 95.809s-111.55-42.852-249.101-95.809Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m412.65-61.548 320.909 630.974a361949.182 361949.182 0 0 1 123.455 242.748s-55.287-108.713-123.455-242.748L412.65-61.548C344.483-195.46 289.195-304.174 289.195-304.174L412.65-61.426v-.122Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#5B5BF5",
    strokeWidth: 0.6,
    d: "m412.65-61.548 320.909 630.974M412.65-61.548C344.483-195.46 289.195-304.174 289.195-304.174L412.65-61.426v-.122Zm320.909 630.974a361949.182 361949.182 0 0 1 123.455 242.748s-55.287-108.713-123.455-242.748Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 572.668,
    cy: 254.437,
    r: 165.554,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-306h1146.21V814H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadicalLineBackground);
export default __webpack_public_path__ + "static/media/RadicalLineBackground.3e94bc91a8aa235d127d316ed45a5868.svg";
export { ForwardRef as ReactComponent };